import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  GetFactoryItemByItemCategoryIDFactoryItemID,
  GetFactoryItemByItemCategoryIDFactoryItemIDGRNWise,
  getfactoriesForDropDown,
  getGroupsForDropdown,
  UpdateFactoryItemGRN,
  GetAllItemsDetails,
  GetSKUNamesByCategoryID,
  GetSKUCategoryNamesByID,
  GetSKUForDropdown,
  GetSKUCategoryForDropdown,
  getBudgetCodeDetails
}


async function GetFactoryItemByItemCategoryIDFactoryItemID(skuCategoryID, budgetcodeID, groupID, factoryID, skuMasterID, itemCode) {
  const response = await CommonGet('/api/FactoryItemNew/GetFactoryItemByItemCategoryIDFactoryItemID', 'itemCategoryID=' + parseInt(skuCategoryID) + '&' + 'budgetcodeID=' + parseInt(budgetcodeID) + '&' + 'factoryItemID=' + parseInt(skuMasterID) + '&' + 'groupID=' + parseInt(groupID) + '&' + 'factoryID=' + parseInt(factoryID) + '&' + 'itemCode=' + itemCode);
  return response;
}

async function GetFactoryItemByItemCategoryIDFactoryItemIDGRNWise(skuCategoryID, factoryItemID, groupID, factoryID) {
  const response = await CommonGet('/api/FactoryItemNew/GetFactoryItemByItemCategoryIDFactoryItemIDGRNWise', 'itemCategoryID=' + parseInt(skuCategoryID) + '&' + 'factoryItemID=' + parseInt(factoryItemID) + '&' + 'groupID=' + parseInt(groupID) + '&' + 'factoryID=' + parseInt(factoryID));
  return response;
}

async function getfactoriesForDropDown(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}
async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function UpdateFactoryItemGRN(updateModel) {
  const response = await CommonPost('/api/FactoryItemNew/UpdateFactoryItemGRN', null, updateModel)
  return response;
}

async function GetAllItemsDetails(groupID, factoryID) {
  const response = await CommonGet('/api/FactoryItemNew/GetAllItemsDetails', 'groupID=' + parseInt(groupID) + '&factoryID=' + parseInt(factoryID));
  return response;
}

async function GetSKUCategoryForDropdown(groupID) {
  var skuCategoryArray = [];
  const response = await CommonGet('/api/SKUMaster/GetSKUTCategories', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true && item[1]["groupID"] == groupID) {
      skuCategoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"]
    }
  }
  return skuCategoryArray;
}

async function GetSKUForDropdown(groupID, budgetcodeID, skuCategoryID) {
  var skuArray = [];
  const response = await CommonGet('/api/SKUMaster/GetSKUTypes', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true && item[1]["groupID"] == groupID && item[1]["skuCategoryID"] == skuCategoryID && item[1]["budgetCodeID"] == budgetcodeID) {
      skuArray[item[1]["skuMasterID"]] = item[1]["skuMasterName"]
    }
  }
  return skuArray;
}

async function GetSKUCategoryNamesByID(budgetCodeID, groupID, factoryID) {
  let response = await CommonGet('/api/SKUCategory/GetSKUCategoryNamesByEstateIDBudgetCodeID', 'budgetCodeID=' + budgetCodeID + '&groupID=' + groupID + '&factoryID=' + factoryID);
  let categoryArray = [];
  for (let item of response.data) {
    categoryArray.push({
      skuCategoryID: item.skuCategoryID,
      skuCategoryName: item.skuCategoryName
    });
  }
  return categoryArray;
}


async function GetSKUNamesByCategoryID(skuCategoryID) {
  let response = await CommonGet('/api/WarehouseSKUMapping/GetSKUNamesByCategoryID', 'skuCategoryID=' + skuCategoryID);
  let skuArray = [];  
  if (Array.isArray(response.data)) {
    for (let item of response.data) {
      if (item.skuMasterID && item.skuMasterName) {
        skuArray.push({
          skuMasterID: item.skuMasterID,
          skuMasterName: item.skuMasterName
        });
      }
    }
  } else {
    for (let item of Object.entries(response.data)) {
      if (item[1]["skuMasterID"] && item[1]["skuMasterName"]) {
        skuArray.push({
          skuMasterID: item[1]["skuMasterID"],
          skuMasterName: item[1]["skuMasterName"]
        });
      }
    }
  }
  return skuArray;
}

async function getBudgetCodeDetails() {
  let response = await CommonGet('/api/BudgetCode/GetAllBudgetCodes', null);
  let budgetCodeArray = [];
  for (let item of Object.entries(response.data)) {
    budgetCodeArray[item[1]["budgetCodeID"]] = item[1]["budgetCodeName"];
  }
  return budgetCodeArray;
};